(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('SellerCampaignService', SellerCampaignService);

    SellerCampaignService.$inject = ['SellerCampaignFactory'];

    function SellerCampaignService(SellerCampaignFactory) {
        const service = {
            findBySellerId: findBySellerId,
            findProgressBySellerId: findProgressBySellerId
        };

        return service;

        function findBySellerId(params) {
            return SellerCampaignFactory.findBySellerId(params).$promise;
        }

        function findProgressBySellerId(params) {
            return SellerCampaignFactory.findProgressBySellerId(params).$promise;
        }
    }
})();
